import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PendingEditProfileListComponent from '../components/pendingEditProfileComponent';
import {  logout,logOutAdmin } from '../../../SuperAdminLogin/actions/superAdminLoginAction'
import { getAllRegionSettings,fetchHeartRunnerDetail,approveHeartRunner ,rejectHeartRunner} 
     from '../actions/pendingEditProfileListAction'; 

class PendingEditProfileListContainer extends Component {
   
    componentWillMount() { 
        /* this.props.actions.fetchHeartRunnerDetail(            
            this.props.dispatch
        )  */
          this.props.actions.getAllRegionSettings(); 
    } 
     getUserList = (data) =>{
                        this.props.actions.fetchHeartRunnerDetail(data,
                            this.props.dispatch
                        )
                    }
    getPendingList = () =>{
        this.props.actions.fetchHeartRunnerDetail(            
            this.props.dispatch
        )
    }
    onApprove=(SelectedRow,regionId)=> {
        
        this.props.actions.approveHeartRunner(
            this.props.heartRunnerList.isLoading,
            SelectedRow,regionId,
            this.props.dispatch)
    }
    onReject=(SelectedRow,regionId)=>{
        
        this.props.actions.rejectHeartRunner(
            this.props.heartRunnerList.isLoading,
            SelectedRow,regionId,
            this.props.dispatch)
    } 
   getRegionData = () => {
                        this.props.actions.getAllRegionSettings(this.props.dispatch);
                     }

    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            <PendingEditProfileListComponent 
                                heartRunnerList={this.props.heartRunnerList}
                                onApprove={this.onApprove}  
                                getPendingList = {this.getPendingList}      
                                onReject={this.onReject} 
                                getRegionList={this.getRegionData}
                                getUserList ={this.getUserList}                   
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            logOutAdmin,
           fetchHeartRunnerDetail,
           approveHeartRunner,
          rejectHeartRunner,
           getAllRegionSettings,
        }, dispatch)
    };
};

function mapStateToProps({ pendingEditProfileReducer, superAdminLoginReducer }) {
    console.log(pendingEditProfileReducer)
    return {
        heartRunnerList: {
            isLoading: pendingEditProfileReducer.isLoading,
            pendingEditProfileList: pendingEditProfileReducer.pendingEditProfileList,
            errorNumber: pendingEditProfileReducer.errorNumber,
            errorMessage: pendingEditProfileReducer.errorMessage,
            messageLabel: pendingEditProfileReducer.messageLabel,
            statusCode:pendingEditProfileReducer.statusCode,
            regionList : pendingEditProfileReducer.regionList,
        },
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.userId
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingEditProfileListContainer))